(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["virasat-collection-hero"] && !Shopify.designMode) return;
  try {
    
  // Filtering from the sidebar reloads only the grid; keep the Mood pills in step with the address
  (() => {
    const sync = () => {
      const tags = new URLSearchParams(window.location.search).getAll('filter.p.tag');
      document.querySelectorAll('.v-coll-hero__moods').forEach((group) => {
        const prefix = group.getAttribute('data-prefix') || '';
        const anyMood = tags.some((tag) => tag.startsWith(prefix));
        group.querySelectorAll('.v-coll-hero__mood').forEach((pill) => {
          const tag = pill.getAttribute('data-tag') || '';
          const active = tag ? tags.includes(tag) : !anyMood;
          if (active) pill.setAttribute('aria-current', 'true');
          else pill.removeAttribute('aria-current');
        });
      });
    };
    // Capture phase, so this runs even if the event does not bubble
    document.addEventListener('shopify:collection:update', sync, true);
    window.addEventListener('popstate', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["virasat-faq"] && !Shopify.designMode) return;
  try {
    
  // Hides questions that do not match the search box, and groups left empty
  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-v-faq-search]')) return;
    const root = input.closest('[data-v-faq]');
    if (!root) return;
    const words = input.value.trim().toLowerCase().split(/\s+/).filter(Boolean);
    let shown = 0;
    root.querySelectorAll('[data-v-faq-group]').forEach((group) => {
      let inGroup = 0;
      group.querySelectorAll('[data-v-faq-item]').forEach((item) => {
        const text = item.textContent.toLowerCase();
        const match = words.every((word) => text.includes(word));
        item.hidden = !match;
        if (match) inGroup += 1;
        if (match && words.length) item.open = true;
      });
      group.hidden = inGroup === 0;
      shown += inGroup;
    });
    const empty = root.querySelector('[data-v-faq-empty]');
    if (empty) empty.hidden = shown > 0;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["virasat-gift-products"] && !Shopify.designMode) return;
  try {
    
  // Budget buttons: show only the tiles whose starting price is in the chosen range
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('.v-gift-budget__btn') : null;
    if (!button) return;
    const root = button.closest('[data-v-gift-grid]');
    if (!root) return;
    const min = Number(button.getAttribute('data-min')) || 0;
    const max = Number(button.getAttribute('data-max')) || 0;
    root.querySelectorAll('.v-gift-budget__btn').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
    root.querySelectorAll('.v-gift-grid > li').forEach((item) => {
      const price = Number(item.getAttribute('data-price')) || 0;
      item.hidden = price < min || (max > 0 && price >= max);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["virasat-visit"] && !Shopify.designMode) return;
  try {
    
  // Opening hours, like Google: "Open · Closes 10 pm", "Closes soon · 10 pm" or
  // "Closed · Opens 10 am Mon", worked out in the shop's time zone, with today in bold
  const vHoursUpdate = (card) => {
    const rows = [...card.querySelectorAll('.v-hours__row')];
    const status = card.querySelector('[data-v-hours-status]');
    if (rows.length !== 7 || !status) return;
    const match = /([+-])(\d{2})(\d{2})/.exec(card.dataset.offset || '');
    const offset = match ? (match[1] === '-' ? -1 : 1) * (Number(match[2]) * 60 + Number(match[3])) : 0;
    const now = new Date(Date.now() + offset * 60000);
    const today = (now.getUTCDay() + 6) % 7;
    const minutes = now.getUTCHours() * 60 + now.getUTCMinutes();
    const t = card.dataset;
    rows.forEach((row, i) => row.classList.toggle('is-today', i === today));

    const row = rows[today];
    const hasHours = row.dataset.open !== undefined;
    const open = Number(row.dataset.open);
    const close = Number(row.dataset.close);
    let tone = 'closed';
    let lead = t.tClosed;
    let rest = '';
    if (hasHours && minutes >= open && minutes < close) {
      tone = close - minutes <= 60 ? 'soon' : 'open';
      lead = tone === 'soon' ? t.tClosesSoon : t.tOpen;
      rest = tone === 'soon' ? row.dataset.closeLabel : `${t.tCloses} ${row.dataset.closeLabel}`;
    } else if (hasHours && minutes < open) {
      rest = `${t.tOpens} ${row.dataset.openLabel}`;
    } else {
      for (let step = 1; step <= 7; step++) {
        const next = rows[(today + step) % 7];
        if (next.dataset.open === undefined) continue;
        rest = `${t.tOpens} ${next.dataset.openLabel} ${(next.dataset.day || '').slice(0, 3)}`;
        break;
      }
    }
    const strong = document.createElement('strong');
    strong.className = `v-hours__state v-hours__state--${tone}`;
    strong.textContent = lead;
    status.replaceChildren(strong, rest ? ` · ${rest}` : '');
    status.hidden = false;
  };

  const vHoursAll = () => {
    const cards = document.querySelectorAll('[data-v-hours]');
    cards.forEach(vHoursUpdate);
    return cards.length > 0;
  };

  const vHoursStart = () => {
    if (vHoursAll()) setInterval(vHoursAll, 60000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vHoursStart, { once: true });
  } else {
    vHoursStart();
  }
  document.addEventListener('shopify:section:load', vHoursAll);

  // Loads the Google Maps embed only after the visitor asks for it
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-v-map-load]') : null;
    if (!button) return;
    const tile = button.closest('[data-v-map]');
    if (!tile) return;
    const frame = document.createElement('iframe');
    frame.src = tile.getAttribute('data-src') || '';
    frame.title = tile.querySelector('.v-visit__map-text')?.textContent || 'Map';
    frame.referrerPolicy = 'no-referrer-when-downgrade';
    frame.className = 'v-visit__map-frame';
    tile.replaceChildren(frame);
    tile.classList.add('v-visit__map--loaded');
  });

  } catch(e) { console.error(e); }
})();
})();
